import { ID, PayloadType } from '../../../types/UtilityTypes'
import {
    FullObject,
    ObjectCloseData,
    ObjectCreateData,
    ObjectUpdateRequest,
    ProjectWorkObject
} from '../../../responses/objects'
import { createAction, createAsyncAction } from 'typesafe-actions'


export const objectActions = {
    startRename: createAction('DATA_OBJECT/START_RENAME')<ProjectWorkObject>(),
    startDelete: createAction('@DATA_OBJECT/START_DELETE')<ProjectWorkObject>(),
    startEdit: createAction('@DATA_OBJECT/START_EDIT')<ProjectWorkObject>(),
    startCreate: createAction('@DATA_OBJECT/START_CREATE')<ID>(),
    startClose: createAction('@DATA_OBJECT/START_CLOSE')<ProjectWorkObject>(),
    startDuplicate: createAction('@DATA_OBJECTS/START_DUPLICATE')<ProjectWorkObject>(),
    cancelEdit: createAction('@DATA_OBJECT/CANCEL_EDIT')(),
    duplicate: createAction('@DATA_OBJECT/DUPLICATE')<ProjectWorkObject>(),
    rename: createAction('@DATA_OBJECT/RENAME')<{object: ProjectWorkObject, name: string}>(),
    create: createAsyncAction(
        '@DATA_OBJECT/CREATE_REQUEST',
        '@DATA_OBJECT/CREATE_SUCCESS',
        '@DATA_OBJECT/CREATE_FAILURE',
    )<ObjectCreateData & { projectId: ID }, undefined, void>(),
    remove: createAsyncAction(
        '@DATA_OBJECT/REMOVE_REQUEST',
        '@DATA_OBJECT/REMOVE_SUCCESS',
        '@DATA_OBJECT/REMOVE_FAILURE'
    )<undefined, ID, void>(),
    update: createAsyncAction(
        '@DATA_OBJECT/UPDATE_REQUEST',
        '@DATA_OBJECT/UPDATE_SUCCESS',
        '@DATA_OBJECT/UPDATE_FAILURE',
    )<{ objectId: ID, changes: ObjectUpdateRequest }, [ProjectWorkObject, PayloadType], void>(),
    close: createAsyncAction(
        '@DATA_OBJECT/CLOSE_REQUEST',
        '@DATA_OBJECT/CLOSE_SUCCESS',
        '@DATA_OBJECT/CLOSE_FAILURE',
    )<ObjectCloseData, FullObject, void>(),
}